export const appName = process.env.MIX_APP_NAME
export const apiBaseUrl = process.env.MIX_APP_URL
export const appUrl = process.env.MIX_APP_PUBLIC_URL
export const api = process.env.MIX_API_URL